import { render, staticRenderFns } from "./UpdateMutiple.vue?vue&type=template&id=c8827986&scoped=true&"
import script from "./UpdateMutiple.vue?vue&type=script&lang=js&"
export * from "./UpdateMutiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8827986",
  null
  
)

export default component.exports